import ClockouController from './core/clockout.controller';
import { ClockoutContext, Institution, Config, User, StyleConfig, Account, ClockoutDataStore } from '@clockout-dev/clockout-components';
import getCookie from './utils/getCookie';

class AppController extends ClockouController {
    async initialize() {
        if (!this.context || this.context.error) {

        }
        else {
            const fi = await this.data.fetchFi(this.context.routingNumber);
            await this.setClockoutContext(fi?.style);    
        }

        this.setState({ loading: false, authenticated: !!getCookie("authentication_token") });
    }

    async handleLoginClick(email) {
        this.context = await this.data.fetchContext();
        await this.initialize();
    }

    async setClockoutContext(style) {
        const { fiName, routingNumber, phoneNumber, givenName, familyName, logonName, email, ssn } = this.context;

        const accounts = this.context?.accounts.map((account) => new Account(account));
        const store = new ClockoutDataStore();
        ClockoutContext.Instance(
            new Institution(fiName, routingNumber, 'LT'),
            new Config('6c1278d308a1b9962ce418e5b66e3b6b', 'STAGING', process.env.REACT_APP_CLOCKOUT_API ?? 'test-api.joinclockout.com'),
            store,
            new User({
                phoneNumber: phoneNumber,
                name: `${givenName} ${familyName}`,
                loginName: logonName,
                ssn: ssn,
                email: email,
                accounts: accounts,
            }),
            new StyleConfig(style)
        );
    }
}

export default AppController;
